import qs from 'query-string'

import { BASE_URL } from '../config'
import axios from '../../function/axiosInstance'

import customFetch from './../../function/customFetch'

const url = `${BASE_URL}/notifications`

export const fetchNotifications = async ({
  query_params = {},
  page = 0,
  page_size = 10
}: {
  query_params?: Partial<NotificationQueryParams>
  page: number
  page_size: number
}): Promise<GetNotifications> => {
  const headers = {
    Authorization: `Bearer ${localStorage.getItem('authToken')}`
  }
  // adding query params
  const reqQueryParams = new URLSearchParams()
  reqQueryParams.append('current_page', page.toString())
  reqQueryParams.append('page_size', page_size.toString())

  Object.keys(query_params).forEach(key => {
    const queryParam = query_params[key]
    // adding query param only if it has valid value (undefined or null or empty string or [])
    if (queryParam?.toString()) {
      reqQueryParams.append(key, queryParam.toString())
    }
  })

  try {
    const response = await customFetch(`${url}?${reqQueryParams.toString()}`, {
      headers
    })
    const result = await response.json()
    if (response.ok) {
      // next page number needed for useInfiniteQuery hook
      const next_page =
        result.total_records - page_size * (page + 1) > 0 ? page + 1 : null
      return {
        status: 'ok',
        data: {
          records: result.records,
          total_records: result.total_records,
          next_page
        },
        error: undefined
      }
    }
    throw new Error(result.description)
  } catch (error) {
    return {
      status: 'error',
      data: {
        records: [],
        total_records: 0,
        next_page: null
      },
      error: error.message
    }
  }
}

export const editNotificationStatus = async ({
  id,
  read_status
}: {
  id: string
  read_status: boolean
}): Promise<ApiResponse> => {
  const headers = {
    Authorization: `Bearer ${localStorage.getItem('authToken')}`,
    'Content-Type': 'application/json'
  }
  try {
    const response = await customFetch(`${url}/${id}/read-status`, {
      method: 'PUT',
      headers,
      body: JSON.stringify({ read_status })
    })
    const result = await response.json()
    if (response.ok) {
      return {
        status: 'ok',
        data: '',
        error: undefined
      }
    }
    throw new Error(result.description)
  } catch (error) {
    return {
      status: 'error',
      data: '',
      error: error.message
    }
  }
}

export const editNotificationsStatus = async ({
  read_status
}: {
  read_status: boolean
}): Promise<ApiResponse> => {
  try {
    const response = await axios.put(`${url}/read-status`, {
      read_status
    })

    if (response.status === 200) {
      return {
        status: 'ok',
        data: '',
        error: undefined
      }
    }
    throw new Error(response.data.description)
  } catch (error) {
    return {
      status: 'error',
      data: '',
      error: error.message
    }
  }
}

export const fetchNotificationCount = async (params?: {
  companyId?: string
}): Promise<GetNotificationsCount> => {
  const headers = {
    Authorization: `Bearer ${localStorage.getItem('authToken')}`
  }
  try {
    const endpoint = qs.stringifyUrl(
      { url: `${url}/stats`, query: { company_id: params?.companyId } },
      { skipNull: true, skipEmptyString: true }
    )

    const response = await customFetch(endpoint, { headers })
    const result = await response.json()
    if (response.ok) {
      return {
        status: 'ok',
        data: result.stats,
        error: undefined
      }
    }
    throw new Error(result.description)
  } catch (error) {
    return {
      status: 'error',
      data: {
        mention: 0,
        primary: 0,
        team: 0,
        total: 0,
        unseen: 0
      },
      error: error.message
    }
  }
}
